import { registerPlugin } from '@capacitor/core';
import type { TwoNPlugin as TwoNPluginInterface } from './definitions';

export * from './definitions';

export const TwoNPlugin = registerPlugin<TwoNPluginInterface>('TwoNPlugin', {
  web: () => import('./web').then(m => new m.TwoNPluginWeb()),
});
